import { useEffect, useRef, useState } from "react";
import "./ScanBarCode.scss";
import { Button, Modal } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
// ZXing-based (open source, no license key); replaces the Dynamsoft scanner whose license expired
import BarcodeScannerComponent from "react-qr-barcode-scanner";

// isOpen: show the camera; value(text) on a successful read, value(null) on cancel
const ScanBarCode = ({ isOpen = false, value = () => {} }) => {
	const [cameraError, setCameraError] = useState("");
	// the scanner keeps the first onUpdate it receives, so read the latest callback through a ref
	const done = useRef(false);
	const valueRef = useRef(value);
	valueRef.current = value;

	useEffect(() => {
		if (isOpen) {
			done.current = false;
			setCameraError("");
		}
	}, [isOpen]);

	const handleUpdate = (err, result) => {
		if (err || !result || done.current) return; // "not found" on most frames is normal
		done.current = true;
		valueRef.current(result.getText().trim());
	};

	const handleError = (error) => {
		const name = error?.name ?? "";
		setCameraError(
			name === "NotAllowedError" || name === "SecurityError"
				? "اجازه دسترسی به دوربین داده نشده است. از تنظیمات مرورگر دسترسی دوربین را برای این سایت فعال کنید."
				: name === "NotFoundError" || name === "OverconstrainedError"
				? "دوربینی روی این دستگاه پیدا نشد. شماره کیت را دستی وارد کنید."
				: "دوربین در دسترس نیست. شماره کیت را دستی وارد کنید.",
		);
	};

	const cancel = () => valueRef.current(null);

	return (
		<Modal onCancel={cancel} className="container-modal-barcode" open={isOpen} closeIcon={<CloseCircleOutlined />} footer={null} destroyOnClose centered>
			<div className="wrapper-barcode">
				<h3>اسکن بارکد کیت</h3>
				<p className="scan-hint">بارکد روی کیت را داخل کادر و به صورت افقی نگه دارید.</p>
				<div className="scan-viewport">
					{cameraError ? (
						<p className="scan-error" role="alert">
							{cameraError}
						</p>
					) : (
						// mounted only while open, so the camera turns off as soon as the modal closes
						isOpen && (
							<>
								<BarcodeScannerComponent width="100%" height="100%" delay={300} onUpdate={handleUpdate} onError={handleError} />
								<div className="scan-frame" aria-hidden="true">
									<span className="scan-line" />
								</div>
							</>
						)
					)}
				</div>
				<div className="holder-footer">
					<Button className="btn-normal" onClick={cancel}>
						انصراف
					</Button>
				</div>
			</div>
		</Modal>
	);
};

export default ScanBarCode;
